import { BarcodeIcon } from "@/components/icons/barcode-icon";
import { OutlinedButton } from "@/components/ui/buttons/OutlinedButton";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface BarcodeOptionProps {
  disabled?: boolean;
}

export const BarcodeOption = memo(function BarcodeOption({ disabled }: BarcodeOptionProps) {
  return (
    <OutlinedButton
      color="black"
      textCase="normal"
      disabled={disabled}
      className="flex items-center justify-between px-3"
    >
      <BarcodeIcon className="h-6 w-6" />
      <span className={textVariants.bodySingleLine}>Scan a barcode (coming soon)</span>
      <div className="h-6 w-6" />
    </OutlinedButton>
  );
});
